
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commerce/address",
      function () {
        return require("private-next-pages/commerce/address/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commerce/address"])
      });
    }
  